import {TiptapPlaceholder} from "../../../forms/inputs/placeholders/TiptapPlaceholder";
import {VueRenderer} from "@tiptap/vue-3";
import PlaceholderListView from "../../../forms/inputs/placeholders/PlaceholderListView.vue";
import tippy from "tippy.js";

export default class Placeholder {

    constructor(placeholders) {
        this.placeholders = placeholders;
    }

    static create(placeholders) {
        return new Placeholder(placeholders);
    }

    getExtensions({ slots }) {
        return [Placeholder.createExtension(this.placeholders, slots.placeholder)];
    }

    static createExtension(placeholders, slot) {
        return TiptapPlaceholder.configure({
            placeholders: placeholders,
            slot: slot,
            suggestion: {
                render: () => {
                    let component
                    let popup
                    return {
                        onStart: properties => {
                            component = new VueRenderer(PlaceholderListView, {
                                editor: properties.editor,
                                props: {
                                    placeholders: placeholders,
                                    command: properties.command,
                                    slot: slot,
                                    editor: properties.editor
                                },
                            });
                            popup = tippy('body', {
                                getReferenceClientRect: properties.clientRect,
                                appendTo: () => document.body,
                                content: component.element,
                                showOnCreate: true,
                                interactive: true,
                                trigger: 'manual',
                                placement: 'bottom-start',
                            });
                        },
                        onUpdate(props) {
                            component.updateProps(props);
                            popup[0].setProps({
                                getReferenceClientRect: props.clientRect,
                            })
                        },
                        onKeyDown(props) {
                            return component.ref?.onKeyDown(props)
                        },
                        onExit() {
                            popup[0].destroy()
                            component.destroy()
                        },
                    }
                },
            },
        })
    }
}